<template>
  <v-app id="app">
    <router-view :key="$route.fullPath"></router-view>
  </v-app>
</template>

<script>
import securityStore from '@/store/security-store'

export default {
  name: 'app',
  data () {
    return {
      showOnXs: false
    }
  },
  methods: {
    handleCollapse (collapsed) {
      if (this.$vuetify.breakpoint.xsOnly) {
        this.showOnXs = false
      } else {
        this.collapsed = collapsed
      }
    },
    handleToolbarSideIconClick () {
      this.showOnXs = !this.showOnXs
    },
    onResize () {
    }
  },
  computed: {
    isAuth () {
      return securityStore.getters.isAuth
    }
  }
}
</script>

<style lang="scss" type="text/scss">
  .polygon {
    background: url('~@/assets/images/polygon.svg') no-repeat center center fixed !important;
    background-size: 100% 100% !important;
  }
</style>
